module.exports = __webpack_public_path__ + "img/HiwaQader-KchiPasha.ae168882.jpg";